// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* About page — professional slate/blue styling that matches the rest of the app
   (see css/OffTheShelf.css for the shared design language). */

.about-page {
  max-width: 980px;
  margin: 0 auto;
  padding: 40px 32px 64px;
  color: #1e293b;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
}

/* ---- Hero ---- */
.about-hero {
  text-align: center;
  margin-bottom: 40px;
}

.about-hero__title {
  margin: 0;
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -0.02em;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.about-hero__tagline {
  margin: 12px auto 0;
  max-width: 640px;
  font-size: 17px;
  font-weight: 500;
  color: #475569;
}

/* ---- Cards ---- */
.about-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 28px 30px;
  margin-bottom: 26px;
  box-shadow: 0 10px 30px rgba(30, 41, 59, 0.08);
  overflow: hidden;
}

/* Accent bar along the top of each card */
.about-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
}

.about-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 6px 0 14px;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.about-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 12px;
  color: #ffffff;
  font-size: 18px;
  background: linear-gradient(90deg, #2563eb, #4f46e5);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
}

.about-card__body {
  margin: 0;
  font-size: 15.5px;
  line-height: 1.75;
  color: #475569;
}

/* ---- Billing highlights ---- */
.about-highlights {
  list-style: none;
  margin: 22px 0 8px;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.about-highlight {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
}

.about-highlight__check {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #16a34a;
  font-size: 16px;
}

.about-highlight__title {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.about-highlight__text {
  display: block;
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
}

/* ---- Charges table ---- */
.about-charges__subtitle {
  margin: 30px 0 14px;
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
}

.about-table-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
}

.about-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.about-table thead th {
  text-align: left;
  padding: 14px 16px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  border-bottom: 1px solid #e2e8f0;
}

.about-table tbody td {
  padding: 16px;
  vertical-align: top;
  border-bottom: 1px solid #eef2f7;
  color: #475569;
  line-height: 1.6;
}

.about-table tbody tr:last-child td {
  border-bottom: none;
}

.about-table tbody tr:hover {
  background: #f8fafc;
}

.about-table__name {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
}

.about-table__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border-radius: 9px;
  color: #2563eb;
  background: #eef2ff;
  font-size: 14px;
}

.about-table__when {
  color: #334155;
  font-weight: 500;
  min-width: 160px;
}

/* ---- Info note ---- */
.about-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 20px 0 0;
  padding: 14px 16px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #475569;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 12px;
}

.about-note__icon {
  flex: 0 0 auto;
  margin-top: 2px;
  color: #d97706;
  font-size: 15px;
}

/* ---- Footer ---- */
.about-footer {
  text-align: center;
  margin-top: 36px;
  color: #94a3b8;
  font-size: 14px;
}

.about-footer svg {
  vertical-align: -2px;
  margin-right: 6px;
}

/* ---- Responsive ---- */
@media (max-width: 760px) {
  .about-page {
    padding: 28px 18px 48px;
  }
  .about-hero__title {
    font-size: 32px;
  }
  .about-highlights {
    grid-template-columns: 1fr;
  }
  .about-table__name {
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutPage.css"],"names":[],"mappings":"AAAA;8DAC8D;;AAE9D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,gFAAgF;AAClF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* About page — professional slate/blue styling that matches the rest of the app\n   (see css/OffTheShelf.css for the shared design language). */\n\n.about-page {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 40px 32px 64px;\n  color: #1e293b;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", sans-serif;\n}\n\n/* ---- Hero ---- */\n.about-hero {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.about-hero__title {\n  margin: 0;\n  font-size: 40px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  background: linear-gradient(90deg, #2563eb, #7c3aed);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.about-hero__tagline {\n  margin: 12px auto 0;\n  max-width: 640px;\n  font-size: 17px;\n  font-weight: 500;\n  color: #475569;\n}\n\n/* ---- Cards ---- */\n.about-card {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  padding: 28px 30px;\n  margin-bottom: 26px;\n  box-shadow: 0 10px 30px rgba(30, 41, 59, 0.08);\n  overflow: hidden;\n}\n\n/* Accent bar along the top of each card */\n.about-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #2563eb, #7c3aed);\n}\n\n.about-card__title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 6px 0 14px;\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.about-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border-radius: 12px;\n  color: #ffffff;\n  font-size: 18px;\n  background: linear-gradient(90deg, #2563eb, #4f46e5);\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);\n}\n\n.about-card__body {\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.75;\n  color: #475569;\n}\n\n/* ---- Billing highlights ---- */\n.about-highlights {\n  list-style: none;\n  margin: 22px 0 8px;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.about-highlight {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px 18px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n}\n\n.about-highlight__check {\n  flex: 0 0 auto;\n  margin-top: 2px;\n  color: #16a34a;\n  font-size: 16px;\n}\n\n.about-highlight__title {\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.about-highlight__text {\n  display: block;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #64748b;\n}\n\n/* ---- Charges table ---- */\n.about-charges__subtitle {\n  margin: 30px 0 14px;\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.about-table-wrap {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.about-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.about-table thead th {\n  text-align: left;\n  padding: 14px 16px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #475569;\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.about-table tbody td {\n  padding: 16px;\n  vertical-align: top;\n  border-bottom: 1px solid #eef2f7;\n  color: #475569;\n  line-height: 1.6;\n}\n\n.about-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.about-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.about-table__name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.about-table__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 30px;\n  border-radius: 9px;\n  color: #2563eb;\n  background: #eef2ff;\n  font-size: 14px;\n}\n\n.about-table__when {\n  color: #334155;\n  font-weight: 500;\n  min-width: 160px;\n}\n\n/* ---- Info note ---- */\n.about-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 20px 0 0;\n  padding: 14px 16px;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: #475569;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 12px;\n}\n\n.about-note__icon {\n  flex: 0 0 auto;\n  margin-top: 2px;\n  color: #d97706;\n  font-size: 15px;\n}\n\n/* ---- Footer ---- */\n.about-footer {\n  text-align: center;\n  margin-top: 36px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.about-footer svg {\n  vertical-align: -2px;\n  margin-right: 6px;\n}\n\n/* ---- Responsive ---- */\n@media (max-width: 760px) {\n  .about-page {\n    padding: 28px 18px 48px;\n  }\n  .about-hero__title {\n    font-size: 32px;\n  }\n  .about-highlights {\n    grid-template-columns: 1fr;\n  }\n  .about-table__name {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
